export default __webpack_public_path__ + "static/media/hht1_home_img_EP2.4c141b62.png";